import { render, staticRenderFns } from "./client-roster-sidebar.vue?vue&type=template&id=0d46c38d"
import script from "./client-roster-sidebar.vue?vue&type=script&lang=js"
export * from "./client-roster-sidebar.vue?vue&type=script&lang=js"
import style0 from "./client-roster-sidebar.vue?vue&type=style&index=0&id=0d46c38d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports